import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const FooterQuoteDetailStyle = styled('div')`
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    background: var(--burgundy-800);
    padding: 24px 0;
    color: var(--sand-100);
    ${typography.bodyL}
    z-index: 99;

    .box-footer {
        display: flex;
        align-items: center;
        gap: 24px;
    }

    .btnLink {
        background-color: var(--orange-300);
        border-color: var(--orange-300);
        height: 56px;
        ${typography.buttonLg}

        &:not(:disabled):hover {
            background-color: var(--orange-400);
            border-color: var(--orange-400);
        }
    }

    .btn-pay {
        ${typography.buttonLg}
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        color: var(--sand-100);
    }

    .link {
        ${typography.bodyXl}
        color: var(--orange-300);
        cursor: pointer;
    }

    .quote-click {
        ${typography.bodySm}
        white-space: nowrap;
        margin-left: auto;
        .btn {
            cursor: pointer;
            &.disabled {
                cursor: not-allowed;
                opacity: 0.75;
            }
        }
        .icon-circle {
            font-size: 1.1rem;
            color: var(--orange-300);
        }
    }

    @media screen and (min-width: 992px) {
        .btnLink {
            min-width: 370px;
        }
    }
    @media screen and (max-width: 991px) {
        .quote-click {
            display: none;
        }
    }
    @media screen and (max-width: 767px) {
        box-shadow: -14px 0px 13px 0px rgba(0, 0, 0, 0.08);
        border-radius: 16px 16px 0 0;

        .box-footer {
            flex-direction: column;
            justify-content: center;
            gap: 10px;
        }

        .btnLink {
            width: 100%;
        }

        .hide-mobile {
            display: none;
        }
    }
`;
export default FooterQuoteDetailStyle;
